import React from 'react';

export const VehicleCheckPointIcon = () => (
  <svg height="26.888" viewBox="0 0 29.116 26.888" width="29.116" xmlns="http://www.w3.org/2000/svg">
    <g id="police" transform="translate(-178.64 -159.6)">
      <g id="svg_11" transform="translate(179 160)">
        <path
          d="M204.574,172.88v-.524a1.789,1.789,0,0,0-1.85-1.722h-2.283l-2.783-4.626a1.03,1.03,0,0,0-.885-.483H189.54a1.007,1.007,0,0,0-.991.741l-.067.282a3.639,3.639,0,0,1,.5.36h.569l.078-.331h2.494v3.155h-.165l1.382,2.3h1.83a2.54,2.54,0,0,1,2.623,2.441v.1a1.88,1.88,0,0,1,.441.429h.376a2.568,2.568,0,0,1,5.123,0h.446a1.135,1.135,0,0,0,1.173-1.092,1.1,1.1,0,0,0-.782-1.03Zm-9.168-1.427h-1.575a.36.36,0,1,1,0-.719h1.575a.36.36,0,1,1,0,.719Zm-2.075-1.721v-3.155h3.375l1.9,3.155Zm0,0"
          fill="none"
          id="svg_2"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-177 -158.676)"
        />
        <path
          d="M201.176,173.336A1.67,1.67,0,1,0,202.965,175,1.73,1.73,0,0,0,201.176,173.336Zm0,2.34A.676.676,0,1,1,201.9,175,.7.7,0,0,1,201.176,175.676Zm0,0"
          fill="none"
          id="svg_3"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-177 -157.733)"
        />
        <path
          d="M179.942,174.962a1.111,1.111,0,0,0-.9,1.062,1.135,1.135,0,0,0,1.173,1.092h1.159v-2.995l-1.43-.421v1.262Zm0,0"
          fill="none"
          id="svg_4"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-179 -157.662)"
        />
        <path
          d="M197.025,174.995v-.524a1.79,1.79,0,0,0-1.85-1.722h-2.283l-2.783-4.626a.968.968,0,0,0-.293-.3l1.2,3.792a1.541,1.541,0,0,1-1.1,1.929l-2.024.6v2.976h3.169a2.568,2.568,0,0,1,5.123,0h.446a1.134,1.134,0,0,0,1.173-1.092,1.1,1.1,0,0,0-.782-1.029Zm0,0"
          fill="none"
          id="svg_5"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-177 -158.149)"
        />
        <path
          d="M193.626,175.451a1.67,1.67,0,1,0,1.789,1.665A1.73,1.73,0,0,0,193.626,175.451Zm0,2.34a.676.676,0,1,1,.725-.675A.7.7,0,0,1,193.626,177.791Zm0,0"
          fill="none"
          id="svg_6"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-177 -157.373)"
        />
        <path
          d="M185.389,162.886l-2.547.109-.109,1.078a1.873,1.873,0,0,0,1.672,2.094,1.644,1.644,0,0,0,1.469-1.125C186.147,164.378,185.815,162.886,185.389,162.886Zm1.417.971"
          fill="none"
          id="svg_8"
          stroke="#0a3256"
          strokeWidth="0.5"
          transform="translate(-177.926 -159.008)"
        />
        <path
          d="M182.675,162.9v.34c0,.4.854.93,1.909.93s1.909-.526,1.91-.93v-.34a1.311,1.311,0,0,0,.706-.436.855.855,0,0,0,.16-.521,1.784,1.784,0,0,0-.85-1.337,3.36,3.36,0,0,0-3.853,0,1.784,1.784,0,0,0-.85,1.337.854.854,0,0,0,.161.522,1.311,1.311,0,0,0,.706.435Zm1.909-1.03c.178,0,.378.269.378.628s-.2.628-.378.628-.378-.269-.378-.628S184.406,161.871,184.584,161.871Zm0,0"
          fill="none"
          id="svg_9"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-178.482 -160)"
        />
        <path
          d="M187.109,173.613l2.577-.759a.83.83,0,0,0,.592-1.039l-1.02-3.2a2.811,2.811,0,0,0-2.7-1.873h-.619a4.035,4.035,0,0,1-.956,2.069l.1-.445a.1.1,0,0,0,0-.045l-.118-.559a.118.118,0,0,0-.118-.09H184.4a.118.118,0,0,0-.118.09l-.118.559a.1.1,0,0,0,0,.045l.1.445a4.035,4.035,0,0,1-.956-2.069h-.556a2.811,2.811,0,0,0-2.7,1.873l-1.02,3.2a.83.83,0,0,0,.592,1.039l2.5.741c0,1.212,0,9.42,0,9.845a1.132,1.132,0,0,0,2.258,0v-8.369h.478v8.369a1.132,1.132,0,0,0,2.258,0c0-.446-.012-8.66-.014-9.824v0Zm0-1.766v-3.275a1.022,1.022,0,0,1,.159.12h0a.933.933,0,0,1,.26.4l.769,2.41-1.169.345-.02.006v-.006Zm-4.965-.013-1.126-.332.769-2.41a.942.942,0,0,1,.358-.479Zm0,0"
          fill="none"
          id="svg_10"
          stroke="#0a3256"
          strokeWidth="0.8"
          transform="translate(-178 -158.403)"
        />
      </g>
    </g>
  </svg>
);
